export default __webpack_public_path__ + "static/media/arrow-right.5251505c.svg";